import { useEffect, useRef } from 'react';

export const CHANNEL_PREFIX = 'vitalcasa-presentacion-';

/**
 * Pantalla tipo TV: la que no es primaria; si no hay, otra distinta a la actual.
 * @param {ScreenDetailed[]} screens
 * @param {ScreenDetailed} current
 */
export function elegirPantallaTv(screens, current) {
  if (!screens?.length) return null;
  const nonPrimary = screens.filter((s) => s.isPrimary === false);
  if (nonPrimary.length > 0) return nonPrimary[0];
  const otra = screens.find((s) => s !== current);
  return otra || current || screens[0];
}

export function resolveFotoUrl(row) {
  const path = typeof row === 'string' ? row : row?.url;
  if (!path) return '';
  if (path.startsWith('http')) return path;
  const base =
    window.location.hostname === 'localhost' ? 'http://localhost:4000' : window.location.origin;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}

/**
 * @param {string} canal
 * @param {(index: number) => void} onGoto
 * @param {(msg: { type: string, show?: boolean, videoIndex?: number }) => void} [onVideoMode]
 * @param {() => void} [onCerrarVisor] — p. ej. window.close() cuando el mando se cierra en el CRM
 */
export function usePresentacionChannel(canal, onGoto, onVideoMode, onCerrarVisor) {
  const ref = useRef(null);
  useEffect(() => {
    if (!canal) return undefined;
    const ch = new BroadcastChannel(CHANNEL_PREFIX + canal);
    ref.current = ch;
    ch.onmessage = (ev) => {
      const d = ev.data;
      if (d?.type === 'goto' && typeof d.index === 'number') {
        onGoto?.(d.index);
      }
      if (d?.type === 'videoMode' && onVideoMode) {
        onVideoMode(d);
      }
      if (d?.type === 'cerrarVisor') {
        onCerrarVisor?.();
      }
    };
    return () => {
      ch.close();
      ref.current = null;
    };
  }, [canal, onGoto, onVideoMode, onCerrarVisor]);
  return ref;
}
